import { FaGoogle } from "react-icons/fa";
import { LoginField } from "..//components/LoginField";
import { useState } from "react";
import RedirectBTN from "../components/RedirectBTN";
import { LoginButton } from "../components/LoginButton";
import { useTheme } from "../../../context/useThemeContext";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { useAccountManagementFunctions } from "../hooks/useAccountManagementFunctions";
import { useFormCooldown } from "../hooks/useFormCooldown";

export default function ForgotPasswordView() {
    const { theme } = useTheme();
    const [email, setEmail] = useState("");
    const { setLoginState } = useAccountManagementStore((state) => state);
    const { resetPassword } = useAccountManagementFunctions();
    const { canSubmit, startCooldown } = useFormCooldown(1);

    async function ForgotPassword() {
        if (!canSubmit) return;

        try {
            await resetPassword(email);
            setLoginState("checkEmail_ForgotPassword");
        } catch (error) {
            console.error("Failed to reset password:", error);
            startCooldown();
        }
    }

    return (
        <form
            id="forgotPasswordForm"
            className="flex flex-col p-9 pb-7 text-center text-white"
            onSubmit={(e) => {
                e.preventDefault();
            }}
        >
            <b className="mb-4 text-2xl">Forgot Password</b>
            <LoginField
                fieldTitle="Email"
                fieldID="email"
                fieldType="email"
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                }}
            />
            <LoginButton
                type="submit"
                className="my-4 h-[36px] rounded text-sm"
                disabled={!canSubmit}
                onClick={() => {
                    ForgotPassword();
                }}
                style={{
                    backgroundColor: theme.accentColor,
                    opacity: canSubmit ? 1 : 0.5,
                    cursor: canSubmit ? "pointer" : "not-allowed",
                }}
            >
                Reset Password
            </LoginButton>
            <div className="flex w-full space-x-2 self-center text-sm">
                <RedirectBTN
                    name="Sign in"
                    onClick={() => {
                        setLoginState("default");
                    }}
                />
                <div className="separator flex-grow-1 flex-1" />
                <RedirectBTN
                    name="Create account"
                    onClick={() => {
                        setLoginState("default");
                    }}
                />
            </div>
        </form>
    );
}
